export default __webpack_public_path__ + "static/media/about.5b9b36e1.md";